const precision = (value, digits = 2) => {
  const multiplier = Math.pow(10, digits);

  return Math.floor(value * multiplier) / multiplier;
};

export default precision;
